export default {"src":"/_next/static/media/channel4.7986ac6b.svg","height":40,"width":29,"blurWidth":0,"blurHeight":0};